module.exports = __webpack_public_path__ + "static/portfolio-mas-8-27c115cfc8cd7de4f15ab6f20ddb4b60.jpg";